<template>
  <div class="app-voucher-thank-you">
    <dyn-slot :slot-data="slotData">
      <slot name="info">
        <h1>AUFLADEN MIT AUFLADENUMMER</h1>
        <p>Vielen Dank! Ihr Guthaben wurde um {{ amountToEuro }} aufgeladen.</p>
      </slot>
    </dyn-slot>
    <b-button class="btn-back" variant="primary" type="button" v-on:click.prevent="back">
      <slot name="btnBack">zurück</slot>
    </b-button>
    <LogOut v-if="showLogout"></LogOut>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import processSteps from '../../../../../mixins/processSteps'
import { stepName as previousProcessStep } from './Input.vue'
import price from '@/mixins/price'
import LogOut from '@/components/process/generic/Authentication/LogOut/LogOut.vue'

export const stepName = 'thankYou'

export default {
  name: 'VoucherThankYou',
  components: { LogOut },
  props: {
    showLogout: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    processSteps(stepName, previousProcessStep, stepName),
    price
  ],
  computed: {
    ...mapGetters('topUp', [
      'amount'
    ]),
    slotData () {
      return {
        amount: this.amountToEuro
      }
    },
    amountToEuro: function () {
      return this.price(this.amount)
    }
  },
  methods: {
    ...mapMutations('topUp', [
      'returnToInput'
    ]),
    back: function () {
      this.returnToInput(this.previousStep)
    }
  }
}
</script>
